export const ActisReportingConstants = {
  PAGE_LOAD: "Page Load",
  CLICKED: " clicked",
  LANDING_PAGE: "Manage Vendor page",
  PRIMARY_LOGO: "Gartner Logomark",
  SECONDARY_LOGO: "Third-Party Cyber Risk Platform",
  GLOBAL_HEADER: "Global Header",
  HELP_CLICKED: "Help Clicked",
  USER_CLICKS_HELP: "User clicks on Help",
  SEARCH_ACTION:
    "User selects a vendor from universal search window from anywhere",
  IN_MY_ORGANIZATION_STATUS: "In My Organization Status",
  OUTSIDE_MY_ORGANIZATION_STATUS: "Outside My Organization Status",
  INVITE_VENDOR: "Invite Vendor",
  INVITE_VENDOR_ACTION:
    "User searches for a vendor from univeral search and initiates invite for a vendor not found",
  PROFILE_MANAGE_TEAM_LABEL: "Profile | Manage Team",
  PROFILE_MANAGE_TEAM_ACTION:
    "User clicks on Manage Team under the Profile section",
  NOTIFICATION: {
    PLACEHOLDER: {
      END_USER_VENDOR_NAME_PLACEHOLDER: "##END_USER_VENDOR_NAME##",
      END_USER_VENDOR_ID_PLACEHOLDER: "##END_USER_VENDOR_ID##",
      NOTIFICATION_HEADER_TEXT: "###NOTIFICATION_HEADER_TEXT###",
      CTA_LABEL: "###CTA_LABEL###",
    },
    LABELS: {
      NOTIFICATION_BELL:
        "Alerts Header Bell icon CTA | ##END_USER_VENDOR_NAME## | ##END_USER_VENDOR_ID##",
      NOTIFICATION_CTA:
        "CTA clicked on Notification panel | ###NOTIFICATION_HEADER_TEXT### | ###CTA_LABEL### | ##END_USER_VENDOR_NAME## | ##END_USER_VENDOR_ID##",
    },
    ACTIONS: {
      NOTIFICATION_BELL: "Alerts Bell icon clicked on any page",
      NOTIFICATION_CTA:
        "CTA on a Notification in Notififcation panel  clicked ",
    },
  },
  ADD_UNKNOWN_VENDOR: {
    LABELS: {
      ADD_UNKNOWN_VENDOR_CTA_GLOBAL_SEARCH:
        "Global Search | Add Unknown Vendor",
    },
    ACTIONS: {
      ADD_UNKNOWN_VENDOR_CTA_GLOBAL_SEARCH:
        'User clicked on Add Vendor CTA within the "Global search" suggestions',
    },
  },
  ASSESSOR: {
    LABELS: {
      SECONDARY_LOGO_CLICK: "###ROLE###",
    },
    ACTIONS: {
      SECONDARY_LOGO_CLICK:
        "User clicks on the Gartner logo in the global navbar on the top",
    },
  },
  APP_LAUNCHER: {
    LABELS: {
      APP_LAUNCHER_EXPANDED: "###PAGE_NAME### | App Launcher Expanded",
      APP_LAUNCHER_COLLAPSED: "###PAGE_NAME### | App Launcher Collapsed",
      APP_LAUNCHER_TOOL_CLICKED:
        "###PAGE_NAME### | ###TOOL_NAME### | Tool launched from App Launcher",
      APP_LAUNCHER_SEE_ALL_TOOLS: "###PAGE_NAME### | See All Tools",
    },
    ACTIONS: {
      APP_LAUNCHER_EXPANDED:
        "User clicked on the App Launcher Icon to expand the menu",
      APP_LAUNCHER_COLLAPSED:
        "User clicked on the App Launcher Icon to collapse the menu",
      APP_LAUNCHER_TOOL_CLICKED: "User launched a tool from the App Launcher",
      APP_LAUNCHER_SEE_ALL_TOOLS:
        "User clicked See All Tools from the App Launcher menu",
    },
  },
  SITE_NAVIGATION: {
    LABELS: {
      VIEW_HOMEPAGE: "View Homepage",
      VIEW_BROWSE_VENDORS_PAGE: "View Browse Vendors Page",
      VIEW_IMPORT_VENDORS_PAGE: "View Import Vendors Page",
      VIEW_ASSESSMENT_DASHBOARD: "View Assessment Dashboard",
      VIEW_MANAGE_VENDORS_PAGE: "View Manage Vendors Page",
      VIEW_TEAM_ACTIVITY_PAGE: "View Team Activity Page",
    },
    ACTIONS: {
      HOMEPAGE: "User clicked on Homepage from the side navigation",
      BROWSE_VENDORS_VISIT:
        "User clicked on Browse Vendors from the side navigation",
      IMPORT_VENDORS_VISIT:
        "User clicked on Import Vendors from the side navigation",
      ASSESSMENT_DASHBOARD_VISIT:
        "User clicked on Assessment Dashboard from the side navigation",
      MANAGE_VENDORS_VISIT:
        "User clicked on Manage Vendors from the side navigation",
      TEAM_ACTIVITY_VISIT:
        "User clicked on Team Activity from the side navigation",
    },
  },
  COMMON_PLACEHOLDERS: {
    ROLE: "###ROLE###",
    PAGE_NAME: "###PAGE_NAME###",
    TOOL_NAME: "###TOOL_NAME###",
  },
};
